import axios from 'axios'
import {
  MOENGAGE_EXPERIENCE_TOKEN,
  MOENGAGE_LIVE_API_KEY,
  URL_MOENGAGE
} from 'config'

export const getPersonalizeContent = async () => {
  const res = await axios.post(
    `${URL_MOENGAGE}/experiences/fetch`,
    {},
    {
      headers: {
        Authorization: `Basic ${MOENGAGE_EXPERIENCE_TOKEN}`,
        'MOE-APPKEY': MOENGAGE_LIVE_API_KEY
      }
    }
  )

  const { data, status } = res

  return { data, status }
}
